'use strict';

var React = require('react');

var SvgResourcesMajor = function SvgResourcesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.47 5.03a.75.75 0 0 1 1.06-1.06l1.267 1.267c.265.264.438.607.494.978l.709 4.73v1.805a3.25 3.25 0 0 1-6.5 0v-.462a3.993 3.993 0 0 0-1 0v.462a3.25 3.25 0 0 1-6.5 0v-1.806l.712-4.718a1.75 1.75 0 0 1 .496-.995l1.262-1.261a.75.75 0 0 1 1.06 1.06l-1.261 1.262a.25.25 0 0 0-.071.143l-.002.01-.574 3.805h3.128c.52 0 .988.227 1.308.588a5.494 5.494 0 0 1 1.884 0c.32-.36.787-.588 1.308-.588h3.13l-.573-3.813a.25.25 0 0 0-.07-.14l-1.267-1.267Zm-1.22 6.72h3.25v1a1.75 1.75 0 1 1-3.5 0v-.75a.25.25 0 0 1 .25-.25Zm-4.5 0h-3.25v1a1.75 1.75 0 1 0 3.5 0v-.75a.25.25 0 0 0-.25-.25Z"
  }));
};
SvgResourcesMajor.displayName = "ResourcesMajor";

exports.SvgResourcesMajor = SvgResourcesMajor;
